import { NoConnectionService } from './pages/no-connection/no-connection.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ErrorHandlingService } from '@common/services/error-handling.service';
import { PreviousRouteService } from '@common/services/previous-route.service';
import { GtmService } from '@common/services/gtm.service';
import { AlertComponent } from '@components/alert/alert.component';
import { NavbarComponent } from '@components/navbar/navbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { NoConnectionComponent } from '@pages/no-connection/no-connection.component';
import { MaintenanceModeComponent } from '@pages/unauth-pages/maintenance-mode/maintenance-mode.component';
import { fromEvent, Subscription } from 'rxjs';
// import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  // providers: [
  //   {
  //     provide: ErrorHandler,
  //     useValue: Sentry.createErrorHandler({
  //       showDialogOfHeldUnitRejection: true,
  //     }),
  //   },
  // ],
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterModule,
    NavbarComponent,
    AlertComponent,
    CommonModule,
    TranslateModule,
    NoConnectionComponent,
    MaintenanceModeComponent,
  ],
})
export class AppComponent implements OnInit {
  error?: any;
  errorTimeout: any;
  isOffline = false;
  isMaintenanceMode = false;
  subscription?: Subscription;

  constructor(
    private errorHandlingService: ErrorHandlingService,
    private noConnectionService: NoConnectionService,
    private previousRouteService: PreviousRouteService,
    private gtmService: GtmService
  ) {}

  ngOnInit(): void {
    this.previousRouteService.startSaveHistory();
    this.initializeAnalytics();

    this.errorHandlingService.alertSubject.subscribe(error => {
      this.error = error;

      if (this.errorTimeout) {
        clearTimeout(this.errorTimeout);
      }

      this.errorTimeout = this.hideError();
    });

    fromEvent(window, 'offline').subscribe(() => {
      this.isOffline = true;
    });

    fromEvent(window, 'online').subscribe(() => {
      if (this.noConnectionService.cachedRequest.value) {
        window.location.reload();
        this.noConnectionService.cachedRequest.next(null);
      }

      this.isOffline = false;
    });

    this.errorHandlingService.maintenanceMode.subscribe(
      value => (this.isMaintenanceMode = value)
    );
  }

  private async initializeAnalytics(): Promise<void> {
    await this.gtmService.updateAnalyticsStatus();
  }

  hideError() {
    return this.error?.code !== 1000
      ? setTimeout(() => this.errorHandlingService.hideError(), 5000)
      : '';
  }
}
